import { useEffect } from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import useShopAdmin from './use-shop-admin'
/*
 * This useEffect hook get's called only when user has shop access
 */
const useEffectShopAccess = (callback: () => void, dependencies: unknown[]): void => {
  const shopAccess = useTypedSelector(state => state.shop.shopAccess)
  const { checkIsShopUserAdmin } = useShopAdmin()
  const isShopAdmin = checkIsShopUserAdmin()
  const selectedCustomerShopToken = useTypedSelector(state => state.shop.selectedUserData?.contextToken)
  const canAccess = (isShopAdmin && selectedCustomerShopToken) || !isShopAdmin
  const currentLanguage = localStorage.getItem('i18nextLng')
  useEffect(() => {
    if (shopAccess && canAccess) {
      callback()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopAccess, currentLanguage, ...dependencies])
}

export default useEffectShopAccess
